import { Auth } from "aws-amplify";
import { CognitoUserSession } from "amazon-cognito-identity-js";
import { signOutUser, setUpdateAvailable } from "../redux/actions/actionCreators";
import { Platform } from "react-native";
import Constants from "expo-constants";

export const createCognitoAuthorizationHeader = async (
  _,
  useAccessToken = false,
  reduxDispatch = (x: any) => null
) => {
  const session = await Auth.currentSession().catch(async (err) => {
    // console.log("Session timed out most likely: ", err);
    reduxDispatch(signOutUser(true));
    throw err;
  });
  const expirationTime = session.getAccessToken().getExpiration();
  const hasExpired = expirationTime * 1000 < Date.now();
  // console.log({ expirationTime, hasExpired });
  if (session.isValid() && !hasExpired) {
    const tokens = getTokens(session);
    const headers = _createCognitoAuthorizationHeader(tokens, useAccessToken);
    return { headers, refreshedTokens: false };
  }

  const refreshToken = session.getRefreshToken();
  return await new Promise(async (resolve, reject) => {
    const cognitoUser = await Auth.currentAuthenticatedUser().catch(async (err) => {
      // console.log(`Error after trying to refresh session should not have happened: `, err);
      reduxDispatch(signOutUser(true));
      return reject(err);
    });

    cognitoUser.refreshSession(refreshToken, async (err: any, refreshedSession: any) => {
      if (err) {
        console.error(err);
        return reject(err);
      }
      const tokens = getTokens(refreshedSession);
      const headers = _createCognitoAuthorizationHeader(tokens, useAccessToken);
      return resolve({ headers, refreshedTokens: false });
    });
  });
};

const _createCognitoAuthorizationHeader = (tokens: any, useAccessToken = false): any => {
  const { accessToken, idToken } = tokens;
  const token = useAccessToken ? accessToken : idToken;
  const res = {
    authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "application/json",
  };

  if (Platform.OS != "web") {
    res.version = Constants?.expoConfig?.version;
  }

  return res;
};

const getTokens = function (session: CognitoUserSession) {
  const res = {
    accessToken: session.getAccessToken().getJwtToken(),
    idToken: session.getIdToken().getJwtToken(),
    refreshToken: session.getRefreshToken().getToken(),
  };
  return res;
};
